module.exports = __webpack_public_path__ + "img/mark-I.a40d9de.svg";